<template>
  <div id="app">
    <router-view :key="key" />
  </div>
</template>

<script>
import Router from 'vue-router'
export default {
  name: "App",
  computed: {
    key() {
      return this.$route.name !== undefined
        ? this.$route.name + +new Date()
        : this.$route + +new Date();
    },
  },
  watch: {
    $route: {
      handler(t, f) {
        // console.log(t, f);
        var to = t.name;
        var fr = f == undefined ? "" : f.name;
        // console.log(to, fr);
        if (f == undefined) {
          //首次加载或刷新
          localStorage.setItem("djzl", 1);
          localStorage.setItem("gsdt", 1);
          localStorage.setItem("cpyc", 1);
        } else {
          if (fr != "B04_djzl" && to != "B04_djzl") {
            localStorage.setItem("djzl", 1);
          }
          if (fr != "B05_gsdt" && to != "B05_gsdt") {
            localStorage.setItem("gsdt", 1);
          }
          if (fr != "B08_cpyc" && to != "B08_cpyc") {
            localStorage.setItem("cpyc", 1);
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    /*设备检测*/
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      // window.location.href = "h5/html/index.html"
      // 移动端操作
      // console.log("移动端操作");
      // window.location.href = "https://www.baidu.com/"

    } else {
      // window.location.href=""
      // PC端操作
      console.log("PC端操作");
    }
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  text-align: center;
  padding-top: 90px;
}
.index .banner .el-carousel__container {
  height: 460px !important;
}
/* .index .banner .el-carousel__indicator--horizontal {
  padding: 12px 12px;
} */
/* .index .banner .el-carousel__indicator--horizontal .el-carousel__button {
  width: 12px;
  height: 12px;
  border-radius: 50%;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue